<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description : 普通文件上传组件, 例如附件之类的
  -->
  <div>
    <el-upload
      action=""
      :accept="format"
      :multiple="false"
      :show-file-list="false"
      :limit="1"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :http-request="upload"
    >
      <slot></slot>
    </el-upload>
    <el-dialog
      top="30vh"
      width="300px"
      title="上传中"
      :visible.sync="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-progress :percentage="progress"></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import OSS from "ali-oss";
import { uploadCover, uploadAgreement } from "@/api/upload";
export default {
  name: "upload-file",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    format: {
      type: String,
      default: "",
    },
    size: {
      // 单位MB
      type: Number,
      default: 1,
    },
    type: {
      type: String,
      default: "",
    },
  },
  watch: {
    value(value) {
      this.url = value;
    },
  },
  data() {
    return {
      resourcesUrl: process.env.VUE_APP_RESOURCES_URL,
      url: "",
      fileList: [],
      visible: false,
      progress: 0,
    };
  },
  created() {},
  methods: {
    beforeUpload(file) {
      if (!(file.size / 1024 / 1024 < this.size)) {
        this.$message.error(`请上传${this.size}MB以内的文件`);
        return false;
      }
      return true;
    },
    upload(file) {
      this.fileList = [];
      this.progress = 0;
      this.visible = true;
      const name = file.file.name;
      const data = {
        AgreementType: this.type,
        Format: name.split(".")[name.split(".").length - 1],
        Name: name,
        Size: file.file.size,
        sts: true,
      };
      uploadAgreement(data)
        .then(({ uploadToken, agreementId }) => {
          const fileName = uploadToken.dir + uploadToken.fileName;
          const ossConfig = {
            region: "oss-cn-hangzhou",
            accessKeyId: uploadToken.accessKeyId,
            accessKeySecret: uploadToken.accessKeySecret,
            stsToken: uploadToken.signature,
            bucket: uploadToken.bucket,
          };
          const client = new OSS(ossConfig);
          client
            .multipartUpload(fileName, file.file, {
              progress: (p) => {
                this.progress = parseInt(p * 100);
              },
            })
            .then(
              (res) => {
                this.visible = false;
                this.$message.success("文件上传成功");
                // this.url = res.agreementId;
                this.$emit("change", agreementId);
              },
              (err) => {
                this.visible = false;
                this.$message.error("oss上传失败");
                console.log("err", err);
              }
            );
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("上传接口调用失败");
          this.visible = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
</style>